import FieldHighlighter from './FieldHighlighter';

export default FieldHighlighter;
